import React from "react";
import styles from "./AccountsPage.module.css";

const AccountRowSkeleton: React.FC = () => {
  return (
    <tr>
      <td data-label="Rank">
        <div
          className={styles.skeleton}
          style={{ width: "1.5rem", height: "0.875rem" }}
        />
      </td>
      <td data-label="Address">
        <div className={styles.addressCell}>
          <div
            className={styles.skeleton}
            style={{ width: "1.125rem", height: "1.125rem", borderRadius: "50%" }}
          />
          <div
            className={styles.skeleton}
            style={{ width: "12rem", height: "0.875rem" }}
          />
        </div>
      </td>
      <td data-label="Balance">
        <div
          className={styles.skeleton}
          style={{ width: "6rem", height: "0.875rem" }}
        />
      </td>
      <td data-label="Verified">
        <div
          className={styles.skeleton}
          style={{ width: "1rem", height: "1rem", borderRadius: "50%" }}
        />
      </td>
      <td data-label="Txn count">
        <div
          className={styles.skeleton}
          style={{ width: "3rem", height: "0.875rem" }}
        />
      </td>
    </tr>
  );
};

export default AccountRowSkeleton;
